import { createSlice } from "../helper";
import { InAWordConstants } from "../../components/specific/Meeting/custom/VideoCall/constants";

const initialState = {
  activeComponent: null,
  currentMemberMeetingId: null,
  urls: {
    checkInUrl: null,
    agendaUrl: null,
    wrapUpUrl: null
  },
  responses: {
    currentMember: {
      pre_meeting: { value: null },
      post_meeting: { value: null },
      memberMeetingId: null
    },
    alternateMember: {
      pre_meeting: { value: null },
      post_meeting: { value: null },
      memberMeetingId: null
    }
  },
  // Below flags are used for Check-In reminder modal control & navigation
  checkInModalTrigger: false,
  targetComponent: null,
  alternateMemberPreMeetingResponseFilled: false
};

const inAWordSlice = createSlice({
  name: 'inAWord',
  initialState,
  reducers: {
    setInitialState: (state, action) => {
      state.activeComponent = action.payload.activeComponent;
      state.urls = action.payload.urls;
      state.checkInModalTrigger = false;
      state.targetComponent = null;
    },
    setActiveComponent: (state, action) => {
      state.activeComponent = action.payload;
    },
    navigateToNext: (state) => {
      if (state.activeComponent === InAWordConstants.ComponentTypes.CHECKIN) {
        state.activeComponent = InAWordConstants.ComponentTypes.AGENDA;
      } else if (state.activeComponent === InAWordConstants.ComponentTypes.AGENDA) {
        state.activeComponent = InAWordConstants.ComponentTypes.WRAPUP;
      }
    },
    navigateToAgenda: (state) => {
      state.activeComponent = InAWordConstants.ComponentTypes.AGENDA;
    },
    setCurrentMemberMeetingId: (state, action) => {
      state.currentMemberMeetingId = action.payload;
    },
    updateMemberResponse: (state, action) => {
      const { memberMeetingId, responseType, value } = action.payload;
      
      const memberType = (memberMeetingId?.toString() === state.currentMemberMeetingId?.toString()) 
        ? 'currentMember' 
        : 'alternateMember';

      state.responses[memberType].memberMeetingId = memberMeetingId;
      state.responses[memberType][responseType].value = value;
    },
    showCheckInModal: (state, action) => {
      state.checkInModalTrigger = true;
      state.targetComponent = action.payload.targetComponent;
    },
    resetCheckInModalTrigger: (state) => {
      state.checkInModalTrigger = false;
    },
    resetTargetComponentOnModalClose: (state) => {
      state.targetComponent = null;
    },
    setAlternateMemberPreMeetingResponseFilled: (state, action) => {
      state.alternateMemberPreMeetingResponseFilled = action.payload;
    }
  }
});

export const inAWordActions = inAWordSlice.actions;

export default inAWordSlice;
